/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const oAuthCredentialStatusSchema = z.object({
  oauthCredentialsId: z.int(),
  status: z.enum(['VALID', 'AUTH_FAILED', 'UNKNOWN']),
});
